export default __webpack_public_path__ + "static/media/1img.f32b96b4.png";